import { BaseUserRoleDTO } from "../../base/base-user-role-dto.model";

export const EXCLUDED_ROLES_FOR_FILTER = ['Translator (en-US)', 'Subscribers', 'Registered Users', 'Unverified Users', 'NTPE', 'NTPE_Supervisor', 'Nontenured',
    // THE FOLLOWING ARE TEMPORARY AND NEED TO BE ADDED BACK IN ONCE WE DO PERMISSIONS ROLE FILTERING
    //'NTPE_Other_Supervisor', 'Sup_Curr_Instruction', 'Sup_Pupil_Services', 'Sup_Spec_Education', 'Sup_Voc_Education', 'CTC_Director', 'Building_Principal'
    'SchoolDistrict_Admin',
];

export const SUPERVISOR_ROLES = ['NTPE_Supervisor', 'NTPE_Other_Supervisor', 'Sup_Curr_Instruction', 'Sup_Pupil_Services', 'Sup_Spec_Education', 'Sup_Voc_Education', 'CTC_Director', 'Building_Principal'];

export class UserRoleHelper {

    public static filterUserRoles(userRoles: BaseUserRoleDTO[] = []) {
        return userRoles.filter(r => !EXCLUDED_ROLES_FOR_FILTER.includes(r?.roleName ?? ''));
    }

    public static isUserroleSupervisor(userRole: BaseUserRoleDTO) {
        return SUPERVISOR_ROLES.includes(userRole?.roleName ?? '');
    }
}